import type { ComboBoxOption } from "@dealer-center/core-components";
import { defaultConfigs } from "@dealer-center/ddc-pages-inventory-config-interface";

export function generateOptions(
  data: string[],
  passedSelectedConfigName?: string
): ExtendedComboBoxOption[] {
  const options: ExtendedComboBoxOption[] = data.map(config => ({
    label: config,
    value: config
  }));
  if (
    passedSelectedConfigName &&
    !options.find(option => option.label === passedSelectedConfigName)
  ) {
    options.unshift({
      label: passedSelectedConfigName,
      value: passedSelectedConfigName,
      isNewConfig: true
    });
  }
  defaultConfigs.forEach(config => {
    if (!options?.find(option => option.label === config)) {
      options?.push({ label: `${config} (default)`, value: config });
    }
  });
  return options;
}

export interface ExtendedComboBoxOption extends ComboBoxOption {
  isNewConfig?: boolean;
}
